import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Tab } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import DeleteModel from "../../components/DeleteModel";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import { AiOutlineDelete } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData, deleteData } from "../../Utility/API";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const MonthlyPromotions = () => {
  const [editData, setEditData] = useState({});
  
  // Form states
  const [day, setDay] = useState("");
  const [prizeValue, setPrizeValue] = useState("");
  const [prizeType, setPrizeType] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [rewardType, setRewardType] = useState("");
  const [isSpecial, setIsSpecial] = useState("");
  const [occasion, setoccasion] = useState("");
  const [multiplier, setMultiplier] = useState("");
  const[boosterValue,setBoosterValue]=useState("");
  const[freespinValue,setFreespinValue]=useState("");
  const [streakTypeField, setStreakTypeField] = useState("");

  // Table states
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Streak-type plans (for filtering rewards per plan + tagging new rewards)
  const [streakTypes, setStreakTypes] = useState([]);
  const [streakFilter, setStreakFilter] = useState("");

  // Delete reward
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleClose = () => {
    setShow(false);
    setEditData({});
  }
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchStreakTypes();
  }, []);

  useEffect(() => {
    fetchMonthlyPromotions();
    setPage(0);
  }, [streakFilter]);

  const fetchStreakTypes = async () => {
    try {
      const response = await getAllData(`${endPoints.api.GET_ALL_STREAK_TYPES}`);
      const data = Array.isArray(response) ? response : response?.data || [];
      setStreakTypes(data);
      // Default the view to the 3-day streak (fallback to the first plan available).
      const defaultPlan = data.find((s) => Number(s?.streak) === 3) || data[0];
      if (defaultPlan?.id != null) {
        setStreakFilter(String(defaultPlan.id));
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Map a streak-type id to a readable label (e.g. "7 Days").
  const streakTypeLabel = (id) => {
    if (id == null || id === "") return "-";
    const match = streakTypes.find((s) => String(s?.id) === String(id));
    return match ? `${match.streak} Days (#${match.id})` : `#${id}`;
  };

  const fetchMonthlyPromotions = async () => {
    setIsLoading(true);
    try {
      // No filter -> all rewards (existing behaviour). Filter -> rewards for that streak type.
      const url = streakFilter
        ? `${endPoints.api.GET_REWARDS_BY_STREAK_TYPE}${streakFilter}`
        : `${endPoints.api.MONTHLY_REWARDS}`;
      const response = await getAllData(url);
      if (Array.isArray(response)) {
        setRows(response);
      } else if (response?.status == "success") {
        setRows(response?.data || []);
      } else {
        ErrorToast("Failed to fetch monthly promotions data");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOk = async () => {
    const isEdit = !!editData?.id;

    // Creating a brand-new reward must be tagged to a streak type.
    if (!isEdit && !streakTypeField) {
      ErrorToast("Please select a Streak Type for the new reward");
      return;
    }

    setIsLoading(true);
    const url = isEdit
      ? `${endPoints.api.UPDATE_MONTHLY_REWARDS}`
      : `${endPoints.api.CREATE_MONTHLY_REWARDS}`;
    const payload = {
      dayNumber: Number(day),
      rewardValue: rewardType == "FREE_SPIN" ? Number(freespinValue) : Number(prizeValue),
      rewardType: rewardType,
      title: title,
      description: description,
      isSpecial: isSpecial == "Yes" ? true : false,
      active: true,
      occasion: occasion,
      multiplier: multiplier,
      booster: rewardType === "BOOSTER" ? Number(boosterValue) : "",
    };
    if (isEdit) {
      payload.id = editData.id;
    } else {
      payload.streak_type = Number(streakTypeField);
    }
    try{
    const response =  await addData(url, payload);
    if(response?.data?.status == "success"){
      SuccesToast(isEdit ? "monthly promotion updated successfully" : "reward created successfully");
      fetchMonthlyPromotions();
      return;
    }
    else{
      ErrorToast(response?.data?.message || response?.message || "Failed to save monthly promotion");
    }
   }
    catch(error){
      console.error("Error saving monthly promotion:", error);
      ErrorToast("Error saving monthly promotion");
    }finally{
      setIsLoading(false);
      handleClose();
    }
  };

  const deleteMonthlyReward = async () => {
    const id = rowDataToDelete?.id;
    setIsLoading(true);
    try {
      const response = await deleteData(`${endPoints.api.DELETE_MONTHLY_REWARDS}${id}`);
      if (response?.status === 200 || response?.data?.status === "success") {
        SuccesToast("reward deleted successfully");
        fetchMonthlyPromotions();
      } else {
        ErrorToast(response?.data?.message || "Failed to delete reward");
      }
    } catch (error) {
      console.error("Error deleting reward:", error);
      ErrorToast("Error deleting reward");
    } finally {
      setIsLoading(false);
      setShowDeleteModal(false);
    }
  };

  useEffect(() => {
    if (editData?.id) {
      setStreakTypeField(editData.streak_type != null ? String(editData.streak_type) : "");
      setDay(editData.dayNumber || "");
      setTitle(editData.title || "");
      setDescription(editData.description || "");
      setRewardType(editData.rewardType || "");
      setIsSpecial(editData.isSpecial ? "Yes" : "No");
      setPrizeValue(editData.rewardValue || "");
      setoccasion(editData.occasion || "");
      setMultiplier(editData.multiplier || "");
      setBoosterValue(editData.booster || "");
     if (editData.rewardType === "FREE_SPIN") {
        setFreespinValue(editData.rewardValue || "");
        setPrizeValue(""); // Clear prize value for free spin
      } else {
        setPrizeValue(editData.rewardValue || "");
        setFreespinValue(""); // Clear free spin value for other types
      }
    }
  }, [editData]);

  return (
    <>
      <Toaster />
      {isLoading && <Loader />}
      <DeleteModel
        showModal={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={deleteMonthlyReward}
      />
      <div className="inner-space12">
        <div className="row">
          <div
            className="col-md-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #444",
              marginLeft:"15px",
              marginTop:"5px",
              marginRight:"15px"
            }}
          >
            <h3
              className="mb-2 mt-2"
              style={{ fontFamily: "ArticulatCF-Bold" }}
            >
              Monthly Promotions
            </h3>
          </div>
        </div>

        <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 25px 0px 25px",
          }}
        >
          <div style={{ width: "260px" }}>
            <Form.Select
              value={streakFilter}
              onChange={(event) => setStreakFilter(event.target.value)}
            >
              <option value="">All Streak Types</option>
              {streakTypes.map((s) => (
                <option key={s?.id} value={s?.id}>
                  {s?.streak} Days
                </option>
              ))}
            </Form.Select>
          </div>
        </div>

        <div className="container-fluid table-custom">
          <div className="row" style={{ padding: "10px"}}>
            <div className="col-md-12">
              <TableContainer component={Paper} style={{overflowX:"hidden"}}>
                <Table
                  className="c_table"
                  size="small"
                  aria-label="Monthly promotions table"
                  stickyHeader
                  sx={{ minWidth: 500 }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Day</TableCell>
                      <TableCell align="center">Title</TableCell>
                      <TableCell align="center">Description</TableCell>
                      <TableCell align="center">Reward Type</TableCell>
                       <TableCell align="center">Reward Value</TableCell>
                       <TableCell align="center">Special Reward</TableCell>
                       <TableCell align="center">Multiplier</TableCell>
                       <TableCell align="center">Booster Value(%)</TableCell>
                       <TableCell align="center">Free spin count</TableCell>
                       <TableCell align="center">Occasion</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? rows.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : rows
                    ).map((row, index) => (
                      <TableRow
                        key={row.id || index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell align="center"> {row?.dayNumber}</TableCell>
                        <TableCell align="center">
                          {row?.title}
                        </TableCell>
                        <TableCell align="center">
                          {row?.description}
                        </TableCell>
                        <TableCell align="center">{row?.rewardType}</TableCell>
                        <TableCell align="center">
                          {row?.rewardType == "FREE_SPIN" ?"" : row?.rewardValue}
                        </TableCell>
                        <TableCell align="center">{row?.isSpecial ? "Yes" : "No"}</TableCell>
                        <TableCell align="center">{row?.multiplier}</TableCell>
                        <TableCell align="center">{row?.booster}</TableCell>
                        <TableCell align="center">{row?.rewardType == "FREE_SPIN" ? row?.rewardValue : ""}</TableCell>
                        <TableCell align="center">{row?.occasion}</TableCell>
                        <TableCell align="center">
                          <div className="row">
                            <div className="col-12">
                              <AiOutlineEdit
                                size={20}
                                style={{ cursor: "pointer", marginRight: "12px" }}
                                onClick={() => {
                                  setEditData(row);
                                  setShow(true);
                                }}
                              />
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={5} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          // { label: "All", value: -1 },
                        ]}
                        colSpan={5}
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "rows per page",
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>

        <Modal
          className="modal-md modal-dialog-centered"
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          dialogClassName="custom-modal-center"
        >
          <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {editData?.id ? "Edit Monthly Promotion" : "Add Monthly Promotion"}
          </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="streakTypeField">
                  <Form.Label>Streak Type</Form.Label>
                  <Form.Select
                    value={streakTypeField}
                    onChange={(event) => setStreakTypeField(event.target.value)}
                    disabled={!!editData?.id}
                  >
                    <option value="">Select Streak Type</option>
                    {streakTypes.map((s) => (
                      <option key={s?.id} value={s?.id}>
                        {s?.streak} Days (#{s?.id})
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="day">
                  <Form.Label>Day</Form.Label>
                  <Form.Select 
                    value={day} 
                    onChange={(event) => setDay(event.target.value)}
                  >
                    <option value="">Select Day</option>
                    {Array.from({length: 30}, (_, i) => (
                      <option key={i + 1} value={i + 1}>Day {i + 1}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="prizeValue">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}   
                    />
                </Form.Group>
              </div>

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}   
                    />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="rewardType">
                  <Form.Label>Reward Type</Form.Label>
                  <Form.Select 
                    value={rewardType} 
                    onChange={(event) => setRewardType(event.target.value)}
                  >
                    <option value="">Select Reward Type</option>
                    <option value="CASH">Cash</option>
                    <option value="BONUS">Bonus</option>
                    <option value="GIFT_CARD">Gift Card</option>
                    <option value="BOOSTER">Booster</option>
                    <option value="FREE_SPIN">Free Spins</option>
                  </Form.Select>
                </Form.Group>
              </div>

                {rewardType === "BOOSTER" && (
                <div className="col-md-6">
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>booster value(%)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter booster value"
                    value={boosterValue}
                    onChange={(e) => setBoosterValue(e.target.value)}   
                    />
                </Form.Group>
              </div>
                )}

                {rewardType === "FREE_SPIN" && (
                <div className="col-md-6">
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>free spin count</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter free spin count"
                    value={freespinValue}
                    onChange={(e) => setFreespinValue(e.target.value)}   
                    />
                </Form.Group>
              </div>
                )}

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="rewardType">
                  <Form.Label>multiplier</Form.Label>
                  <Form.Select 
                    value={multiplier} 
                    onChange={(event) => setMultiplier(event.target.value)}
                  >
                    <option value="">Select Multiplier</option>
                    <option value="1">1x</option>
                    <option value="2">2x</option>
                    <option value="3">3x</option>
                    <option value="4">4x</option>
                    <option value="5">5x</option>
                  </Form.Select>
                </Form.Group>
              </div>

               {(rewardType === "GIFT_CARD" ||
               rewardType === "CASH" ||
               rewardType === "BONUS") && (
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="prizeValue">
                  <Form.Label>Prize Value</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Prize Value"
                    value={prizeValue}
                    onChange={(e) => setPrizeValue(e.target.value)}   
                    />
                </Form.Group>
              </div>
              )}

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="prizeValue">
                  <Form.Label>occasion</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter occasion"
                    value={occasion}
                    onChange={(e) => setoccasion(e.target.value)}   
                    />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="isSpecial">
                  <Form.Label>Special Reward</Form.Label>
                  <Form.Select 
                    value={isSpecial} 
                    onChange={(event) => setIsSpecial(event.target.value)}
                  >
                    <option value="">Select isSpecial</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </Form.Group>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleOk}
              style={{
                background: "#04631e",
                borderColor: "#04631e",
              }}
            >
              {editData?.id ? "Update Promotion" : "Create Promotion"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default MonthlyPromotions;
